"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const tools_1 = require("../tools");
const BaseModel_1 = tslib_1.__importDefault(require("./BaseModel"));
const createOrganizationInvites_graphql_1 = tslib_1.__importDefault(require("../gql/organizations/mutations/createOrganizationInvites.graphql"));
const deleteOrganizationInvite_graphql_1 = tslib_1.__importDefault(require("../gql/organizations/mutations/deleteOrganizationInvite.graphql"));
const resendOrganizationInvite_graphql_1 = tslib_1.__importDefault(require("../gql/organizations/mutations/resendOrganizationInvite.graphql"));
const acceptOrganizationInvite_graphql_1 = tslib_1.__importDefault(require("../gql/organizations/mutations/acceptOrganizationInvite.graphql"));
class OrganizationInvite extends BaseModel_1.default {
    constructor() {
        super(...arguments);
        this.createMutation = '';
        this.updateMutation = '';
    }
    defaults() {
        var _a;
        return {
            uuid: '',
            emails: [],
            organization: {
                uuid: (_a = tools_1.getStore()) === null || _a === void 0 ? void 0 : _a.state.route.params.organizationUuid,
            },
        };
    }
    sendInvites() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const invites = yield this.mutate(createOrganizationInvites_graphql_1.default, {
                organizationUuid: this.organization.uuid,
                emails: this.emails,
            });
            return invites.map(i => this.hydrate(i));
        });
    }
    accept() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate(acceptOrganizationInvite_graphql_1.default, { uuid: this.uuid });
        });
    }
    delete() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate(deleteOrganizationInvite_graphql_1.default, {
                uuid: this.uuid,
            });
        });
    }
    resend() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate(resendOrganizationInvite_graphql_1.default, {
                uuid: this.uuid,
            });
        });
    }
}
exports.default = OrganizationInvite;
//# sourceMappingURL=OrganizationInvite.js.map